import { createContext as e, useCallback as t, useContext as n, useEffect as r, useState as i } from "react";
import { jsx as a } from "react/jsx-runtime";
//#region src/components/theme-provider.tsx
var o = e(void 0), s = () => {
	let e = n(o);
	if (!e) throw Error("useTheme must be used within an InfoveaveTheme component");
	return e;
}, c = ({ children: e }) => {
	let [n, s] = i("indigo"), [c, l] = i(!1), u = t(() => {
		l((e) => !e);
	}, []);
	r(() => {
		let e = document.documentElement;
		e.setAttribute("data-theme", n), c ? e.classList.add("dark") : e.classList.remove("dark");
	}, [n, c]);
	let d = {
		primaryColor: n,
		darkMode: c,
		setPrimaryColor: s,
		setDarkMode: l,
		toggleDarkMode: u
	};
	return /* @__PURE__ */ a(o.Provider, {
		value: d,
		children: e
	});
};
c.displayName = "InfoveaveTheme";
//#endregion
export { c as InfoveaveTheme, s as useTheme };
